module.exports = __webpack_public_path__ + "fonts/Calibre-Regular.e0823214.woff";